import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import LeftBar from '../../../../left-bar/LeftBar';
import LeftBarContainer from '../../content/CustomLeftBarContainer';
import TabBar from '../../../../tab-bar/TabBar';
import CoverFlowWrapper from '../../../../coverflow/CoverFlowWrapper';
import MainManager from '../../../../content/MainManager';

import Sample from '../../content/Sample';

import { setStateFullScreen } from "../../../../../../actions/index";

function ConnectedPlayEnv({
  maxWidth, maxHeight, fullHeight, playerCoordinates,
  isFullScreen, setStateFullScreen,
  isSampler
}) {

  let blockHeightSampler = isSampler ? 120 : 0;
  let widthSampler = (fullHeight) ? 155 : 150;

  const leftBarContainerHeight = (fullHeight) ? maxHeight : maxHeight - playerCoordinates.height;
  const leftBarContainerStyle = {}
  // const leftBarContainerHeight = (fullHeight) ? maxHeight - 10 : maxHeight - playerCoordinates.height - blockHeightSampler;
  // const leftBarContainerStyle = (fullHeight)
  // ? { top: Config.LEFT_PAD_TOP }
  // : { top: Config.LEFT_PAD_TOP + playerCoordinates.height + blockHeightSampler};
  const toggleFullScreen = (e, state = null) => { setStateFullScreen((state !== null) ? state : !isFullScreen) }
  const styleTabbar = { top: playerCoordinates.height };

  return (
    <>
      <LeftBar height={maxHeight}>
        <LeftBarContainer height={leftBarContainerHeight} fullHeight={fullHeight} style={leftBarContainerStyle} />
      </LeftBar>

      <div className={`flexColumn`}>
        <CoverFlowWrapper maxWidth={maxWidth} isFullHeight={fullHeight}
          height={ isFullScreen ? maxHeight : playerCoordinates.height }
          isFullScreen={isFullScreen} onFullScreen={toggleFullScreen} />
        { isSampler && (
          <div className={`flexRow`} style={{height: blockHeightSampler, background: `#151517`, marginLeft: Config.SIDE_WIDTH * -1, zIndex: (fullHeight) ? 9 : 10}}>
            <div className={`flexColumn`} style={{position: `absolute`, left: (fullHeight) ? Config.SIDE_WIDTH : 0, marginTop: 4}}>
              <div className={`flexRow`}>
                <Sample name={`Air Horn`} width={widthSampler} />
                <Sample name={`Uhh`} width={widthSampler} />
                <Sample name={`Echo Bleep`} width={widthSampler} />
                <Sample name={`Chord 1`} width={widthSampler} />
              </div>
              <div className={`flexRow`}>
                <Sample name={`Spaceship`} width={widthSampler} />
                <Sample name={`Impact`} width={widthSampler} />
                <Sample name={`Chord 2`} width={widthSampler} />
                <Sample name={`Radiobytes`} width={widthSampler} />
              </div>
            </div>
            <div className={`flexColumn`} style={{position: `absolute`, right: 0, marginTop: 4}}>
              <div className={`flexRow`}>
                <Sample name={`Drum Hat`} width={widthSampler} />
                <Sample name={`Cymbal`} width={widthSampler} />
                <Sample name={`Drum Kick`} width={widthSampler} />
                <Sample name={`Drum Snare`} width={widthSampler} />
              </div>
              <div className={`flexRow`}>
                <Sample name={`Vox 1`} width={widthSampler} />
                <Sample name={`DJ`} width={widthSampler} />
                <Sample name={`House Kick`} width={widthSampler} />
                <Sample name={`House Clap`} width={widthSampler} />
              </div>
            </div>
          </div>
        )}
        <TabBar style={styleTabbar} />
        <MainManager
          maxWidth={maxWidth} height={maxHeight - playerCoordinates.height - 40 - blockHeightSampler}
          playerCoordinates={playerCoordinates} fullHeight={fullHeight} playerDrop={false}
        />
      </div>
    </>
  )

}

ConnectedPlayEnv.propTypes = {
  maxWidth: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  isSampler: PropTypes.bool,
  playerCoordinates: PropTypes.object.isRequired
}

const PlayEnv = connect(
  state => ({
    isFullScreen: state.isFullScreen,
    isSampler: state.ISampler
  }),
  dispatch => ({
    setStateFullScreen: state => dispatch(setStateFullScreen(state))
  })
)(ConnectedPlayEnv);

export default PlayEnv;
